import Card from "antd/es/card/Card";
import Processes from "entities/Processes";
import { isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import Search from "shared/components/Input";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const List = () => {
  const [pagination, setPagination] = useState({});
  const [search, setSearch] = useState("");
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const LIST = t("LIST", { returnObjects: true });
  const [duplicateProcess] = useMutation(graphql.mutations.DUPLICATE_PROCESS, {
    refetchQueries: [
      {
        query: graphql.queries.PROCESSES,
        awaitRefetchQueries: true,
        variables: {
          ...INITIAL_VALUES,
          like: isEmpty(search)
            ? undefined
            : {
                OR: [{ name: `%${search}%` }],
              },
        },
      },
    ],
    onCompleted: ({ duplicateProcess }) => {
      navigate(
        `${SCREENS.PRIVATE.ADMIN.PROCESSES.DETAIL.path}/${duplicateProcess.id}`,
      );
    },
  });
  const filter = {
    ...INITIAL_VALUES,
    like: isEmpty(search)
      ? undefined
      : {
          OR: [{ name: `%${search}%` }],
        },
  };
  const navigate = useNavigate();

  const buttons = [
    {
      icon: <MdAdd size={24} />,
      text: LIST.HEADER.SAVE,
      onClick: () => navigate(SCREENS.PRIVATE.ADMIN.PROCESSES.CREATE.path),
    },
  ];

  return (
    <>
      <Header title={LIST.HEADER.TITLE} actions={buttons} />
      <Card type="simple">
        <div className="m-bottom-20 grid--4">
          <Search
            placeholder={LIST.SEARCH}
            type="search"
            onChange={({ target: { value } }) => {
              setPagination((prev) => ({ ...prev, skip: 0 }));
              setSearch(value);
            }}
          />
        </div>
        <Processes
          View={View}
          filter={{ ...filter, ...pagination }}
          setValues={setPagination}
          skip={pagination.skip || 0}
          NoData={View}
          duplicate={duplicateProcess}
        />
      </Card>
    </>
  );
};

export default List;
